import { defineMessage } from 'services/localization';

export const messages = {
    readonlyBadge: defineMessage('readonly'),
    integrationDisconnected: defineMessage('disconnected_1'),
    airwallexDisconnected: defineMessage('disconnected_from_airwallex'),
    amCaptureBadge: defineMessage('approvalmax_capture'),
};
